import React from "react";

interface WallModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: "normal" | "window") => void;
  onDelete: () => void;
}

const WallModal: React.FC<WallModalProps> = ({
  isOpen,
  onClose,
  onSelectType,
  onDelete,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-xl w-72 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="w-full py-3 my-2 rounded-lg text-white font-medium text-sm transition hover:opacity-90 bg-blue-600"
          onClick={() => onSelectType("normal")}
        >
          일반 벽
        </button>
        <button
          className="w-full py-3 my-2 rounded-lg text-white font-medium text-sm transition hover:opacity-90 bg-green-500"
          onClick={() => onSelectType("window")}
        >
          창문 벽
        </button>
        <button
          className="w-full py-3 my-2 rounded-lg text-white font-medium text-sm transition hover:opacity-90 bg-red-500"
          onClick={onDelete}
        >
          삭제
        </button>
      </div>
    </div>
  );
};

export default WallModal;
